import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputNumber } from 'antd';
import { getIn } from 'formik';

function NumericInput(props) {
  const { field, form, label, ...restProps } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  const { name, onChange, onBlur, value } = field;
  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <InputNumber
        name={name}
        value={value}
        onChange={e => {
          onChange({ target: { value: e, name } });
        }}
        onBlur={onBlur}
        min={0}
        placeholder={label}
        {...restProps}
      />
    </Form.Item>
  );
}
NumericInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  id: PropTypes.string
};
export default NumericInput;
